import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {Button} from "reactstrap";

const breadcrumbStatic = [{
	name: "Work Orders Worked",
	url: '/managers/wos_worked',
	icon: 'dashboard'
}];

export default class WosWorked extends Framework.Components.View {
	constructor(props) {
		super(props);
	}

	render() {
		let {history} = this.props;
		return(
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={history}/>

				<div className={"row"}>
					<div className={"col"}>
						<Collections.WosWorked history={history} managerView={true}/>
					</div>
				</div>
			</div>
		)
	}
}
